import { getEnumById } from './helpers';

export enum OfferingType {
	CONSUMER2B = 'CONSUMER2B',
	CONSUMER3 = 'CONSUMER3',
	CONSUMER4 = 'CONSUMER4',
	CONSUMER5 = 'CONSUMER5',

	B2B1 = 'B2B1',
	B2B2 = 'B2B2'
}

export const allOfferingTypes = [OfferingType.CONSUMER2B, OfferingType.CONSUMER3, OfferingType.CONSUMER4, OfferingType.CONSUMER5, OfferingType.B2B1, OfferingType.B2B2];

// TODO convert these to enum
export const ACCOUNT_TYPE_CONSUMER = 'consumer';
export const ACCOUNT_TYPE_BUSINESS = 'business';

export const getAccountType = (offeringTypeId: string) => {
	const offeringType = getEnumById(offeringTypeId, allOfferingTypes);
	if (offeringType === OfferingType.CONSUMER2B || offeringType === OfferingType.CONSUMER3 || offeringType === OfferingType.CONSUMER4 || offeringType === OfferingType.CONSUMER5) {
		return ACCOUNT_TYPE_CONSUMER;
	} else if (offeringType === OfferingType.B2B1 || offeringType === OfferingType.B2B2) {
		return ACCOUNT_TYPE_BUSINESS;
	} else {
		throw new Error('assertion failed');
	}
};
